<div class="not-found">
  <div class="not-found__content">
    <h1 class="not-found__code">404</h1>
    <h2 class="not-found__title">Page Not Found</h2>
    <p class="not-found__body">
      The page you are looking for does not exist.
    </p>
    <button class="btn btn-primary not-found__button" routerLink="/service-providers" type="button">
      Back to Home
    </button>
  </div>
</div>